import { useMemo } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { PersonStatuses } from "~enums/personStatuses";
import type { LabelValue } from "~types/labelValue.ts";
import CustomSelect from "../CustomSelect";

type Props = {
  className?: string;
  disabled?: boolean;
  defaultValue?: string | { value: string; label: string }[];
  placeholder?: string;
  multiple?: boolean;
  value?: LabelValue | LabelValue[];
  onChange?: (value: LabelValue | LabelValue[] | undefined) => void;
};

const SelectPersonStatus = ({ className, disabled, onChange, defaultValue, value, multiple, placeholder }: Props) => {
  const { formatMessage } = useIntl();

  const options = useMemo(
    () => Object.values(PersonStatuses).map((value) => ({ value, label: formatMessage({ id: `personStatus.${value}` }) })),
    [formatMessage],
  );

  return (
    <CustomSelect
      style={{ minWidth: "130px" }}
      value={value}
      defaultValue={defaultValue}
      onChange={(_, option) => {
        if (multiple) {
          onChange?.(option as { value: string; label: string }[]);
        } else {
          onChange?.(option as { value: string; label: string });
        }
      }}
      options={options}
      placeholder={placeholder || <FormattedMessage id="status" />}
      allowClear
      className={className}
      disabled={disabled}
      mode={multiple ? "multiple" : undefined}
    />
  );
};

export default SelectPersonStatus;
